import styled from 'styled-components';

export const StyledPaymentPage = styled.div`
    .switch {
        justify-content: center;
        margin-bottom: 15px;
        font-family: var(--bllink-font-primary);
        font-size: 18px;
    }

    .cards-wrapper {
        display: flex;
        gap: 30px;
    }

    .btn-wrapper {
        width: 100%;
        margin-top: 70px;
        display: flex;
        justify-content: flex-end;

        .app-btn {
            font-family: var(--bllink-font-headers);
            font-weight: 400;
            height: 60px;
            font-size: 20px;
            position: relative;
            padding-left: ${({ ltr }) => ltr ? '' : '50px'};
            padding-right: ${({ ltr }) => ltr ? '50px' : ''};

            .arrow {
                transform: ${({ ltr }) => ltr ? 'rotate(180deg)' : 'rotate(0deg)'};
                position: absolute;
                right: ${({ ltr }) => ltr ? '10px' : ''};
                left: ${({ ltr }) => ltr ? '' : '10px'};
            }
        }
    }

    @media screen and (max-width: 768px) {      
        .switch {
            font-size: 16px;
        }
        
        .cards-wrapper {
            flex-direction: column;
            gap: 50px;
        }

        .app-btn {
            width: 100%;
        }
    }
`

export const StyledPaymentPageCard = styled.div`
    padding: 16px 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
    background: rgba(255, 255, 255, 0.7);
    box-shadow: 0px 8px 30px rgba(67, 57, 126, 0.1);
    border-radius: 20px;
    width: 370px;
    font-family: var(--bllink-font-primary);
    height: fit-content;

    .border-bottom {
        border-bottom: 1px solid rgba(220, 220, 226, 0.5);
    }

    .card-title {
        font-weight: 700;
        font-size: 20px;            
        color: #373647;
        display: flex;
        justify-content: center;
        gap: 18px;
        padding: 16px;
        width: 100%;
    }

    .payment {
        font-weight: 400;
        font-size: 18px;
        color: rgba(55, 54, 71, 0.7);
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding: 14px;
        width: 100%;
        text-align: center;

        .currency-value, .value {
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 700;
            font-size: 18px;
            color: #373647;
        }
    }

    .dropdown {
        background: #F3F1FF;
        border-radius: 20px;
        font-size: 18px;
        color: #373647;
        padding: 10px;
        text-align: center;
        margin: 22px 0 -16px;
        cursor: pointer;
        width: 370px;
        position: relative;

        .dropdown-arrow {
            position: absolute;
            left: 24px;
            top: 50%;
            transform: ${({ opened }) => opened ? 'rotate(90deg) translateX(-50%)' : 'rotate(270deg) translateX(50%)'};
        }
    }

    .info {
        background: #E6E3FC;
        box-shadow: 0px 8px 30px rgba(67, 57, 126, 0.1);
        border-radius: 0 0 20px 20px;
        width: 370px;
        margin-bottom: -16px;
        padding: 30px 20px 20px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .check-all {
            align-self: flex-start;
            margin-bottom: 8px;
        }

        .icon-wrap {
            width: 18px !important;
            height: 18px !important;
            border-radius: 2px !important;
            border-color: var(--bllink-purple) !important;

            img {
                width: 10px !important;
            }
        }

        .checked {
            background-color: var(--bllink-purple);
        }

        .mark-as-paid {
            margin: 12px 0;
            text-transform: uppercase;
            color: var(--bllink-purple);
            cursor: pointer;
            font-family: var(--bllink-font-headers);
            font-size: 14px;
        }

        .currency-value {
            font-weight: 700;
        }

        .app-btn {
            background-color: transparent;
            text-transform: uppercase;
            width: 150px;
            min-width: unset;
            padding: 10px;
            border: 2px solid var(--bllink-purple);
            font-size: 14px;
        }
    }

    @media screen and (max-width: 768px) {
        width: 320px;
    
        .dropdown {         
            margin: 16px 0 -16px;
            width: 320px;
    
            .dropdown-arrow {
                left: 21px;
            }
        }

        .info {
            width: 320px;
        }
    
    }
`
